import { LegacyDevice } from 'console/device/device';
import { getLegacyOpenThermThermometers, getLegacyRadioThermometers, getLegacyWeatherThermometer, getSharedThermometer, isOutsideThermometer, isRadioThermometer, } from './utils';
export function getLegacyThermometers(device) {
    const { rf_status, ot_enabled } = device;
    const thermometers = LegacyDevice.active_thermometers(device?.thermometers || []);
    const boiler_adapter_thermometers = ot_enabled
        ? getLegacyOpenThermThermometers(device)
        : [];
    const radio_thermometers = getLegacyRadioThermometers(thermometers, rf_status).map(getSharedThermometer);
    const weather_thermometer = getLegacyWeatherThermometer(device, thermometers.find(isOutsideThermometer));
    const shared_thermometers = thermometers
        .filter((thermometer) => !isOutsideThermometer(thermometer))
        .filter((thermometer) => !isRadioThermometer(thermometer))
        .map(getSharedThermometer);
    const legacy_thermometers = [
        ...shared_thermometers,
        ...radio_thermometers,
        ...boiler_adapter_thermometers,
        weather_thermometer,
    ];
    return legacy_thermometers;
}
